<template>
	<div class="EditReportNarrative">
		<!-- Narrative header -->
		<div id="narrative-header" class="Page-section Page-section--primaryLight">
			<div class="Page-section-inner Page-section-inner--md">
				<CloMessage v-if="errorMessage" role="error" title="">
					{{ errorMessage }}
				</CloMessage>
				<CloHeading level="2">{{ narrative ? $t('tripReport.editNarrative') : $t('tripReport.narrativeAdd') }}</CloHeading>
				<p class="u-margin-none">
					{{ $t('tripReport.editNarrativeDesc') }}
				</p>
			</div>
		</div>
		<!-- Narrative content -->
		<div id="narrative-content" class="Page-section">
			<div class="Page-section-inner Page-section-inner--md">
				<!-- If loading... -->
				<CloLoadingAnimation v-if="gettingNarrative" class="LoadingAnimation LoadingAnimation--large LoadingAnimation--basic" />
				<!-- If the current user doesn't have to lock, they see a message and can take the lock by clicking a button -->
				<!-- <div v-else-if="!hasLock">
					<div class="Message Message--alert">
						<div class="Message-title">
							<CloIcon symbol="warning" style="color: white" />
						</div>
						<div class="Message-content">{{ $t('tripReport.narrativeLockedDesc') }}</div>
					</div>
					<button class="Button" @click="takeoverNarrative()">{{ $t('tripReport.narrativeTakeOver') }}</button>
				</div>-->
				<!-- If the current user has the lock, they can edit the narrative -->
				<form>
					<CloInputTextarea id="inputId" name="narrative" :maxlength="64000" @input="narrativeTextEntered" v-model="narrative" />
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import CloHeading from '@/base/CloHeading/CloHeading.vue';
import CloGridAuto from '@/grid/CloGridAuto/CloGridAuto.vue';
import CloInputTextarea from '@/forms/CloInputTextarea/CloInputTextarea.vue';
import CloMessage from '@/layouts/CloMessage/CloMessage.vue';
import CloDialog from '@/base/CloDialog/CloDialog.vue';
import CloLoadingAnimation from '@/base/CloLoadingAnimation/CloLoadingAnimation';
import CloIcon from '@/icons/CloIcon/CloIcon';
export default {
	name: 'EditReportNarrative',
	components: {
		CloHeading,
		CloGridAuto,
		CloInputTextarea,
		CloMessage,
		CloDialog,
		CloLoadingAnimation,
		CloIcon,
	},
	data() {
		return {
			baseUrl: window.baseUrl,
			tripApiBaseUrl: window.tripApiBaseUrl,
			tripManageApiBaseUrl: window.tripManageApiBaseUrl,
			csrf: window['_csrf'],
			csrf_header: window['_csrf_header'],
			dataHasChanged: false,
			narrative: '',
			gettingNarrative: false,
			//hasLock: false,
			errorMessage: '',
		};
	},
	props: {
		reportId: {
			type: Number,
			required: true,
		},
		locale: String,
	},
	mounted() {
		this.getNarrative();
	},
	computed: {},
	methods: {
		setDataHasChanged() {
			this.dataHasChanged = true;
		},
		getNarrative() {
			this.gettingNarrative = true;
			let url = `${this.tripApiBaseUrl}narrative/${this.reportId}`;
			axios
				.get(url)
				.then((res) => {
					// api returns null if no comments
					if (res.data) {
						if (!(Object.keys(res.data).length === 0)) {
							this.narrative = res.data.narrative.replace(/<br\/\>/gi, '\n');
						}
					}
					this.gettingNarrative = false;
				})
				.catch((err) => {
					console.log('failed', err);
				});
		},
		// getLock() {
		// 	this.gettingLockStatus = true;
		// 	let url = `${this.tripManageApiBaseUrl}lock-narrative/${this.reportId}`;
		// 	let headers = {};
		// 	headers[this.csrf_header] = this.csrf;
		// 	axios
		// 		.post(
		// 			url,
		// 			{},
		// 			{
		// 				headers: headers,
		// 				withCredentials: true,
		// 			}
		// 		)
		// 		.then((res) => {
		// 			if (res.data) {
		// 				if (res.data === true) {
		// 					// lock obtained, fetch narrative
		// 					this.hasLock = true;
		// 					this.gettingLockStatus = false;
		// 					this.getNarrative();
		// 				}
		// 			}
		// 		})
		// 		.catch((err) => {
		// 			// HTTP 409 Conflict when unable to obtain lock, which we handle in UI
		// 			// if different status show an error message
		// 			if (err.response.status !== 409) {
		// 				this.errorMessage = this.$i18n.t('tripReport.narrativeLockError');
		// 			}
		// 			this.gettingLockStatus = false;
		// 		});
		// },
		// takeoverNarrative() {
		// 	this.gettingLockStatus = true;
		// 	let url = `${this.tripManageApiBaseUrl}takeover-narrative/${this.reportId}`;
		// 	let headers = {};
		// 	headers[this.csrf_header] = this.csrf;
		// 	axios
		// 		.post(
		// 			url,
		// 			{},
		// 			{
		// 				headers: headers,
		// 				withCredentials: true,
		// 			}
		// 		)
		// 		.then((res) => {
		// 			// user has taken over and now has lock
		// 			this.hasLock = true;
		// 			this.gettingLockStatus = false;
		// 			this.getNarrative();
		// 		})
		// 		.catch((err) => {
		// 			console.log('failed', err);
		// 			this.errorMessage = this.$i18n.t('tripReport.narrativeErrorFetchingLock');
		// 		});
		// },
		// unlockNarrative(fromBackBtn) {
		// 	// don't unlock narrative from back button unless current user has the lock.
		// 	if (fromBackBtn) {
		// 		if (!this.hasLock) {
		// 			return;
		// 		}
		// 	}

		// 	let url = `${this.tripManageApiBaseUrl}unlock-narrative/${this.reportId}`;
		// 	let headers = {};
		// 	headers[this.csrf_header] = this.csrf;
		// 	axios
		// 		.post(
		// 			url,
		// 			{},
		// 			{
		// 				headers: headers,
		// 				withCredentials: true,
		// 			}
		// 		)
		// 		.then((res) => {
		// 			// it's unlocked, good
		// 		})
		// 		.catch((err) => {
		// 			console.log('failed', err);
		// 			this.errorMessage = this.$i18n.t('tripReport.narrativeErrorFetchingLock');
		// 		});
		// },
		saveNarrative() {
			if (this.dataHasChanged) {
				let url = `${this.tripManageApiBaseUrl}update-narrative/${this.reportId}`;
				let formData = new FormData();
				formData.append('narrative', this.narrative);
				let headers = {};
				headers[this.csrf_header] = this.csrf;
				axios
					.post(url, formData, {
						headers: headers,
						withCredentials: true,
					})
					.then((res) => {
						window.location = baseUrl + 'tripreport/' + this.reportId;
					})
					.catch((err) => {
						// HTTP 409 Conflict when another user took over the lock
						//if (err.response.status === 409) {
						//	this.errorMessage = this.$i18n.t('tripReport.narrativeErrorConflict');
						//} else {
						//	this.errorMessage = this.$i18n.t('tripReport.narrativeErrorConflict');
						//}
					});
			} else {
				window.location = baseUrl + 'tripreport/' + this.reportId;
			}
		},
		narrativeTextEntered() {
			this.setDataHasChanged();
		},
	},
};
</script>

<style lang="scss">
.EditReportNarrative {
	height: 100%;
	display: flex;
	flex-direction: column;
	#narrative-content {
		flex-grow: 1;
		display: flex;
		flex-direction: column;
	}
	.Page-section-inner {
		flex-grow: 1;
		width: 100%;
	}
	.EditReportNarrative-narrative,
	form,
	.InputTextarea,
	.InputTextarea-field {
		height: 100%;
		width: 100%;
	}
	.InputTextarea-field {
		resize: none;
		@include inset-md;
	}
}
</style>
